import { blue20opacity15, blue20opacity20, blue60 } from '../../../colors/blue';
import { neutral60opacity10 } from '../../../colors/neutral';
import { rem } from '../../../utils/rem';
/**
 * List styles pseudo states hierarchy:
 * 1. selected + hover
 * 2. selected
 * 3. hover
 * 4. focus-visible
 * 5. default
 */
export var listStyles = {
    focusVisible: {
        backgroundColor: 'transparent',
        outline: "solid ".concat(rem(1), " ").concat(blue60),
    },
    hover: {
        backgroundColor: neutral60opacity10,
    },
    focused: {
        outline: "solid ".concat(rem(1), " ").concat(blue60),
        outlineColor: blue60,
    },
    selected: {
        backgroundColor: blue20opacity15,
    },
    // Combinations of states
    focusHover: {
        backgroundColor: neutral60opacity10,
    },
    selectedHover: {
        backgroundColor: blue20opacity20,
    },
};
export var MuiListItem = {
    styleOverrides: {
        root: {
            paddingTop: 0,
            paddingBottom: 0,
            minHeight: rem(34),
            transitionDuration: '75ms',
            // Focus, hover and selected states
            '&[class*=Mui-focusVisible], &:focus-visible[tabindex]': {
                outline: listStyles.focusVisible.outline,
                backgroundColor: listStyles.focusVisible.backgroundColor, // should be transparent by default and changed only if other states are present
            },
            // Hover only if button prop is true - deprecated but we have to support it
            '&.MuiListItem-button:hover, &[class*=Mui-focusVisible]:hover': {
                backgroundColor: listStyles.hover.backgroundColor,
            },
            "&[class*='Mui-selected'], &[class*='Mui-selected'].Mui-focusVisible, &[class*='Mui-selected']:focus-visible[tabindex]": {
                backgroundColor: listStyles.selected.backgroundColor,
            },
            "&[class*='Mui-selected']:hover": {
                backgroundColor: listStyles.selectedHover.backgroundColor,
            },
            '& [class*=MuiCheckbox-root]': {
                margin: 0,
            },
        },
        dense: {
            paddingTop: 0,
            paddingBottom: 0,
            minHeight: rem(28),
        },
        gutters: {
            paddingInline: rem(12),
        },
    },
};
